import React, { useState } from 'react';

import FaqItem from 'on_web/components/shared/FAQ/FaqItem';
import FaqSearch from 'on_web/components/shared/FAQ/FaqSearch';

export default function Faq(props) {
  const [searchedTerm, setSearchedTerm] = useState([]);

  const isSearchedTermInContent = content => {
    let isInContent = false;
    content.forEach(content => {
      if (content.toLowerCase().indexOf(searchedTerm[0].toLowerCase()) !== -1) {
        isInContent = true;
      }
    });
    return isInContent;
  };

  const isSearchedTermFound = item => {
    if (
      searchedTerm != null &&
      searchedTerm.length > 0 &&
      searchedTerm[0] !== ''
    ) {
      return (
        isSearchedTermInContent(item.content) ||
        item.title.toLowerCase().indexOf(searchedTerm[0].toLowerCase()) !== -1
      );
    } else {
      return true;
    }
  };

  return (
    <>
      <div style={{ marginBottom: '20px' }}>
        <FaqSearch
          hint={'Search'}
          onSearch={newSearchedTerm => setSearchedTerm([newSearchedTerm])}
        />
      </div>
      {props.items
        .filter(item => isSearchedTermFound(item))
        .map((item, ix) => {
          return (
            <FaqItem
              key={ix}
              title={item.title}
              content={item.content}
              searchedTerms={searchedTerm}
              isSearched={
                searchedTerm != null &&
                searchedTerm.length > 0 &&
                searchedTerm[0] !== '' &&
                isSearchedTermInContent(item.content)
              }
              {...props.accordion}
            />
          );
        })}
    </>
  );
}
